import '@/assets/fonts/font-awesome.min.css';
import "umaui/dist/style.css";
import '@/assets/main.css';
import messages from './translations.js';

import { createApp } from 'vue'
import { createI18n } from 'vue-i18n';
import App from './App.vue'
import router from './router'

export const i18n = createI18n({
    messages,
    locale: window.lang || 'pt', 
});

const app = createApp(App)
app.use(i18n);
app.use(router)
app.mount('#app')
